<template>
    <div class="flex flex-wrap">
        <div class="w-full">
            <div class="mb-4">
                <h1 class="font-bold text-3xl mb-4">Save time with human expertise.</h1>
                <p>No time to polish your episode? Our podcast team can handle it for you.</p>
            </div>
            <div class="pb-1/1 rounded-lg bg-cover bg-no-repeat bg-center" :style="{ backgroundImage: `url('${img}')`}">
            </div>
        </div>
        <div class="flex flex-wrap w-full">
            <div class="w-full">
                <div>
                    <div class="w-full flex items-end mb-3">
                        <div class="mr-2 font-medium">Which option would you like?</div>
                        <!-- <span class="text-gray-600 border-dotted border-b border-gray-600 leading-tight text-sm">Help me choose</span> -->
                    </div>
                    <div class="mb-10">
                        <div class="flex justify-between bg-gray-200 rounded-2xl p-2 mb-3">
                            <div v-for="plan in plans" @click="select(plan)" :class="{
                                'bg-regal-blue-700 text-white' : plan.active,
                                'text-gray-700' : !plan.active,
                            }" class="w-1/2 text-sm text-center px-4 py-3 cursor-pointer rounded-xl font-medium">
                                {{ plan.title }}
                            </div>
                        </div>
                        <div v-if="plans[0].active" class="ml-1 text-sm">
                            <div v-for="feature in plans[0].features" class="flex items-center mb-2">
                                <svg class="w-5 h-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                                {{ feature }}
                            </div>
                        </div>
                        <div v-if="plans[1].active" class="ml-1 text-sm">
                            <div v-for="feature in plans[1].features" class="flex items-center mb-2">
                                <svg class="w-5 h-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                                {{ feature }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex flex-wrap justify-between items-center mb-10">
                    <div class="flex-1 w-full">
                        <div class="mb-2 font-medium">How long is the recorded episode?</div>
<!--                             <div class="text-gray-600 text-sm mr-2">Get your podcast returned in less than 48 hours</div> -->
                    </div>
                    <segment-select :options="duration"></segment-select>
                </div>

                <div class="flex justify-between items-center mb-4">
                    <div class="flex-1">
                        <div class="font-medium">Quick turnaround</div>
                        <div class="text-gray-600 text-sm mr-2">Get your episode returned in less than 48 hours.</div>
                    </div>
                    <toggle-switch @clicked="quickTurnaround = !quickTurnaround" :active="quickTurnaround"></toggle-switch>
                </div>
            </div>

            <div class="w-full flex flex-wrap justify-between items-center self-end pt-4">
                <a href="mailto:hello@pager.fm">
                    <Button label="Contact team" type="secondary"/>
                </a>
                <div @click="submit">
                    <Button :label="'Continue (' + price + ')'" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SegmentSelect from '@/Shared/SegmentSelect'
    import ToggleSwitch from '@/Shared/ToggleSwitch'
    import { computed, ref } from 'vue'
    import { usePage } from '@inertiajs/inertia-vue3'
    import Button from '@/Shared/Button'

    export default {
        setup() {
            const user = computed(() => usePage().props.value.auth.user)
            return { user }
        },
        components: {
            SegmentSelect, ToggleSwitch, Button
        },
        props: ['img', 'configuration', 'open', 'fileTypes'],
        setup() {
            const duration = ref([
                {
                    title: '> 5min',
                    active: false,
                    multiplier: 1
                },
                {
                    title: '5–30min',
                    active: false,
                    multiplier: 1.8
                },
                {
                    title: '30–60min',
                    active: true,
                    multiplier: 3.4
                },
                {
                    title: '60+ min',
                    active: false,
                    multiplier: 4.7
                },
            ])

            const plans = ref([
                    {
                        title: 'Basic',
                        active: true,
                        multiplier: 1,
                        features: ['Clean up your audio', 'Reduce background noise', 'Export audio file']
                    },
                    {
                        title: 'Pro',
                        active: false,
                        multiplier: 2.2,
                        features: ['Everything from Basic', 'Remove um’s or long pauses', 'Restructure your episode to flow seamlessly', 'Add your intro/outro', 'Add your music/jingles', 'Mix your audio professionally']
                    }
            ])

            const quickTurnaround = ref(false)

            const selectedPlan = ref('Basic')


            return { duration, plans, quickTurnaround, selectedPlan }
        },
        created() {
            this.updateMailto()
            if (this.configuration) {
                if (this.configuration.plan) {
                    this.plans.forEach((plan, i) => {
                        if (this.configuration.plan == plan.title) {
                            this.select(plan)
                        }
                    })
                }
                if (this.configuration.duration) {
                    this.duration.forEach((duration, i) => {
                        duration.active = false
                        if (this.configuration.duration == duration.title) {
                            duration.active = true
                        }
                    })

                }
                if (this.configuration.quickTurnaround) {
                    this.quickTurnaround = true
                }
            }

        },
        watch: {
            price: function() {
                this.updateMailto();
            }
        },
        emits: ['submit', 'back'],
        methods: {
            submit() {
                let duration = this.duration.filter(duration => duration.active).length > 0 ? this.duration.filter(duration => duration.active)[0].title : '';
                const data = {
                    'quickTurnaround': this.quickTurnaround,
                    'plan': this.selectedPlan,
                    'duration': duration,
                    'price': this.price
                }
                this.$emit('submit', data)
            },
            updateMailto() {
                var quickTurnaroundString = "";
                if (this.quickTurnaround) {
                    quickTurnaroundString = " Also, I need this in less than 48 hours.";
                }
                var subject = "🎵 Expert Audio Editing";
                var cc = this.cc;
                var duration = this.duration.filter(duration => duration.active).length > 0 ? this.duration.filter(duration => duration.active)[0].title : '';
                var message =
`Hi Pager,

I‘d love to get some editing help for my ` + duration + ` podcast. I‘m interested in the ` + this.selectedPlan + ` package for ` + this.price + `.` + quickTurnaroundString + `

Thanks,
` + this.name;
                this.mailto = "mailto:hello@pager.fm?cc=" + encodeURIComponent(cc) + "&subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(message);
            },
            select(plan) {
                this.plans.forEach((el) => {
                    el.active = false;
                    if (el.title == plan.title) {
                        el.active = true;
                        this.selectedPlan = plan.title;
                    }
                });
            },
        },
        computed: {
            price() {
                var basePrice = 3200;
                var durationMultiplier = this.duration.filter(duration => duration.active).length > 0 ? this.duration.filter(duration => duration.active)[0].multiplier : 1;
                var planMultiplier = this.plans.filter(plan => plan.active).length > 0 ? this.plans.filter(plan => plan.active)[0].multiplier : 1;
                var turnaroundMultiplier = this.quickTurnaround ? 3 : 1;
                var price = basePrice * durationMultiplier * planMultiplier * turnaroundMultiplier;
                return '$' + (price / 100).toFixed(2).toLocaleString('en');
            }
        }
    }
</script>
